import _Radio from "@arco-design/web-react/es/Radio";
import _Tag from "@arco-design/web-react/es/Tag";
import _Divider from "@arco-design/web-react/es/Divider";
import _Typography from "@arco-design/web-react/es/Typography";
import _Space from "@arco-design/web-react/es/Space";
import _Button from "@arco-design/web-react/es/Button";
import _Modal from "@arco-design/web-react/es/Modal";
import _Link from "@arco-design/web-react/es/Link";
import _Popover from "@arco-design/web-react/es/Popover";
import _Grid from "@arco-design/web-react/es/Grid";
import _Dropdown from "@arco-design/web-react/es/Dropdown";
import _Message from "@arco-design/web-react/es/Message";
import _useRequest from "@byted/hooks/es/useRequest";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useEffect, useState } from 'react';
import { IconSettings, IconDelete, IconCaretDown, IconCopy } from '@arco-design/web-react/icon';
import { DeleteTheme, ListMyThemes } from '@src/utils/api/theme';
import { useDispatch } from 'react-redux';
import ThemeEdit from '@src/pages/common/themeEdit';
import style from './style.less';
import DeletePng from '@src/assets/delete.png';
import PublishHistory from '@src/pages/common/publishHistory';
import { copyText } from '@src/utils/dom';
import { getPkgVersions } from '@src/utils/api/common';
import IconReact from '@src/assets/svg/react.svg';
import IconVue from '@src/assets/svg/vue.svg';
import VoteIcon from '@src/pages/common/voteIcon';
import ThemeSync from '../themeSync';
import IconParentTheme from '@src/assets/svg/parent-theme.svg';
import useLocale from '@src/hooks/useLocale';
import locale from '../locale';
import { formatDesignPageUrl } from '@src/utils/hooks/useBreadcrumb';
import qs from 'query-string';
import { themeDepLibrary } from '@src/utils/constants';
import { formatImgUrl } from '@src/utils/format';
function ThemeMenu(props) {
  var _this = this;
  var _a, _b;
  var defaultVisible = !!((_a = qs.parse(location.search)) === null || _a === void 0 ? void 0 : _a.showThemeEdit);
  var t = useLocale(locale).t;
  var theme = props.theme,
    readonly = props.readonly;
  var dispatch = useDispatch();
  var _c = __read(useState([]), 2),
    versions = _c[0],
    setVersions = _c[1];
  var themeList = _useRequest(function () {
    return __awaiter(_this, void 0, void 0, function () {
      var list;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (themeList === null || themeList === void 0 ? void 0 : themeList.length) {
              return [2, themeList];
            }
            return [4, ListMyThemes({
              pageSize: 100
            })];
          case 1:
            list = _a.sent().list;
            return [2, list];
        }
      });
    });
  }, {
    auto: theme.isMine
  }).data;
  var _d = _useRequest(function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4, DeleteTheme({
                themeId: theme.themeId
              })];
            case 1:
              _a.sent();
              _Message.success(t['dropdown.message.deleted']);
              location.href = '/themes/stores/manage';
              return [2];
          }
        });
      });
    }),
    loading = _d.loading,
    deleteTheme = _d.run;
  useEffect(function () {
    var name = theme.depLibrary;
    name && getPkgVersions({
      packageName: name
    }).then(function (res) {
      var versions = res.versions;
      setVersions(versions.filter(function (x) {
        return x.indexOf('-') === -1;
      }));
    });
  }, [theme.depLibrary]);
  return /*#__PURE__*/React.createElement(_Dropdown, {
    trigger: ['hover', 'click'],
    position: "bottom",
    triggerProps: {
      popupAlign: {
        bottom: [20, 12]
      },
      clickToClose: false,
      mouseEnterDelay: 20
    },
    defaultPopupVisible: defaultVisible,
    droplist: /*#__PURE__*/React.createElement("div", {
      className: style['dropdown-menu']
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Grid.Row, {
      className: style['dropdown-menu-title'],
      justify: "space-between",
      align: "center"
    }, /*#__PURE__*/React.createElement("span", null, theme.packageName ? t['dropdown.packageName.published'] : t['dropdown.packageName.unpublish']), !readonly && /*#__PURE__*/React.createElement("span", {
      onMouseLeave: function onMouseLeave(e) {
        e.stopPropagation();
      }
    }, /*#__PURE__*/React.createElement(ThemeEdit, {
      readonly: readonly,
      theme: theme,
      onOk: function onOk(newTheme) {
        if ((newTheme === null || newTheme === void 0 ? void 0 : newTheme.depVersion) !== theme.depVersion) {
          location.reload();
        }
        if (newTheme) {
          dispatch({
            type: 'updateThemeConfig',
            payload: newTheme
          });
        }
      },
      defaultVisible: defaultVisible
    }, /*#__PURE__*/React.createElement(_Popover, {
      content: t['dropdown.ThemeEdit.setting.tip']
    }, /*#__PURE__*/React.createElement(_Link, null, /*#__PURE__*/React.createElement(IconSettings, {
      style: {
        fontSize: 16
      }
    })))), /*#__PURE__*/React.createElement(_Popover, {
      content: t['dropdown.ThemeEdit.delete.tip']
    }, /*#__PURE__*/React.createElement(_Link, {
      style: {
        marginLeft: 12
      }
    }, /*#__PURE__*/React.createElement(IconDelete, {
      style: {
        fontSize: 16
      },
      onClick: function onClick() {
        var modal = _Modal.confirm({
          icon: null,
          title: null,
          footer: null,
          content: /*#__PURE__*/React.createElement("div", {
            className: style['delete-modal'],
            style: {
              textAlign: 'center'
            }
          }, /*#__PURE__*/React.createElement("img", {
            src: DeletePng,
            style: {
              width: 277
            }
          }), /*#__PURE__*/React.createElement("p", {
            className: style['delete-modal-desc']
          }, t['dropdown.ThemeEdit.delete.confirm.desc']), /*#__PURE__*/React.createElement("div", {
            style: {
              marginTop: 20
            }
          }, /*#__PURE__*/React.createElement(_Button, {
            status: "danger",
            shape: "round",
            className: style['delete-modal-action'],
            style: {
              marginRight: 12
            },
            onClick: deleteTheme,
            loading: loading
          }, t['dropdown.ThemeEdit.delete.btn']), /*#__PURE__*/React.createElement(_Button, {
            shape: "round",
            disabled: loading,
            onClick: function onClick() {
              modal.close();
            }
          }, t['dropdown.ThemeEdit.cancel.btn'])))
        });
      }
    }))))), /*#__PURE__*/React.createElement(_Space, {
      size: 14
    }, /*#__PURE__*/React.createElement(VoteIcon, {
      type: "like",
      theme: theme,
      showCount: true,
      onOk: function onOk(st) {
        dispatch({
          type: 'updateThemeConfig',
          payload: __assign(__assign({}, theme), {
            statistic: st
          })
        });
      }
    }), /*#__PURE__*/React.createElement(VoteIcon, {
      type: "star",
      theme: theme,
      showCount: true,
      onOk: function onOk(st) {
        dispatch({
          type: 'updateThemeConfig',
          payload: __assign(__assign({}, theme), {
            statistic: st
          })
        });
      }
    }), /*#__PURE__*/React.createElement(VoteIcon, {
      type: "copy",
      theme: theme,
      showCount: true
    }), /*#__PURE__*/React.createElement(VoteIcon, {
      type: "view",
      theme: theme,
      showCount: true
    })), theme.packageName && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Grid.Row, {
      justify: "space-between",
      align: "center",
      className: style['dropdown-menu-desc'],
      onClick: function onClick() {
        var text = "" + theme.packageName;
        if (copyText(text)) {
          _Message.success({
            content: t['dropdown.ThemeEdit.copy.success']
          });
        } else {
          _Message.error(t['dropdown.ThemeEdit.copy.error']);
        }
      }
    }, /*#__PURE__*/React.createElement("span", null, theme.packageName), /*#__PURE__*/React.createElement(_Link, null, /*#__PURE__*/React.createElement(IconCopy, {
      style: {
        fontSize: 16
      }
    }))), /*#__PURE__*/React.createElement("span", {
      onMouseLeave: function onMouseLeave(e) {
        e.stopPropagation();
      }
    }, t['dropdown.ThemeEdit.supplement.text'], /*#__PURE__*/React.createElement(PublishHistory, {
      theme: theme,
      onReset: function onReset() {
        location.reload();
      }
    }, /*#__PURE__*/React.createElement(_Typography.Text, {
      type: "primary",
      style: {
        cursor: 'pointer'
      }
    }, t['dropdown.ThemeEdit.supplement.history']))))), /*#__PURE__*/React.createElement(_Divider, {
      className: style.divider
    }), /*#__PURE__*/React.createElement(_Space, {
      size: 6
    }, /*#__PURE__*/React.createElement(_Typography.Paragraph, {
      style: {
        margin: 0
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: style['dropdown-menu-title']
    }, t['dropdown.ThemeEdit.menu.title'], " "), theme.depLibrary === themeDepLibrary['vue'] ? /*#__PURE__*/React.createElement(_Tag, {
      size: "small",
      style: {
        background: '#E0F9EE',
        color: '#41B883'
      }
    }, /*#__PURE__*/React.createElement(IconVue, {
      style: {
        marginRight: 4
      }
    }), "Vue") : /*#__PURE__*/React.createElement(_Tag, {
      size: "small",
      style: {
        background: '#E1F8FE',
        color: '#15AFD9'
      }
    }, /*#__PURE__*/React.createElement(IconReact, {
      style: {
        marginRight: 4
      }
    }), "React")), /*#__PURE__*/React.createElement(_Tag, {
      size: "small"
    }, versions[0] === theme.depVersion || !theme.depVersion ? t['dropdown.ThemeEdit.menu.tag.latest'] : t['dropdown.ThemeEdit.menu.tag.updatable'])), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Typography.Paragraph, {
      style: {
        margin: 0,
        color: 'var(--color-text-3)',
        marginTop: 6
      }
    }, theme.depLibrary, "@", theme.depVersion || versions[0])), theme.origin && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Divider, {
      className: style.divider
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Typography.Paragraph, {
      style: {
        marginBottom: 8,
        fontWeight: 600
      }
    }, t['dropdown.ThemeEdit.origin.title']), /*#__PURE__*/React.createElement(_Grid.Row, {
      justify: "space-between",
      align: "center"
    }, /*#__PURE__*/React.createElement(_Typography.Text, {
      type: "secondary",
      ellipsis: true,
      style: {
        flex: 1,
        fontSize: 12,
        margin: 0
      }
    }, /*#__PURE__*/React.createElement(IconParentTheme, {
      style: {
        fontSize: 14,
        marginRight: 4,
        verticalAlign: -3,
        color: '#6A98FF'
      }
    }), (_b = theme.origin) === null || _b === void 0 ? void 0 : _b.themeName), /*#__PURE__*/React.createElement(_Divider, {
      type: "vertical",
      style: {
        margin: ' 0 4px 0 8px'
      }
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      onMouseLeave: function onMouseLeave(e) {
        e.stopPropagation();
      }
    }, /*#__PURE__*/React.createElement(ThemeSync, {
      theme: theme
    }, /*#__PURE__*/React.createElement(_Link, {
      style: {
        lineHeight: '18px',
        fontSize: 12
      }
    }, t['dropdown.ThemeEdit.origin.synchronization']))), /*#__PURE__*/React.createElement(_Link, {
      style: {
        lineHeight: '18px',
        fontSize: 12
      },
      href: formatDesignPageUrl(theme.origin.themeId),
      target: "_blank"
    }, t['dropdown.ThemeEdit.origin.check']))))), !readonly && themeList && themeList.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Divider, {
      className: style.divider
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: style['dropdown-menu-title-slim']
    }, t['dropdown.ThemeEdit.toggle.title']), /*#__PURE__*/React.createElement(_Radio.Group, {
      direction: "vertical",
      defaultValue: theme.themeId,
      onChange: function onChange(themeId) {
        location.href = location.href.replace("/" + theme.themeId + "/", "/" + themeId + "/");
      },
      options: themeList.map(function (item) {
        return {
          label: item.themeName,
          value: item.themeId
        };
      }).sort(function (a) {
        return a.value === theme.themeId ? -1 : 1;
      })
    }))))
  }, /*#__PURE__*/React.createElement(_Grid.Row, {
    align: "center",
    style: {
      flexWrap: 'nowrap'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: style.logo
  }, /*#__PURE__*/React.createElement("img", {
    src: formatImgUrl(theme.logo),
    alt: "logo"
  })), /*#__PURE__*/React.createElement("span", {
    className: style.title
  }, theme.themeName, props.isPreviewPage ? t['dropdown.ThemeEdit.preview'] : theme.isMine ? '' : t['dropdown.ThemeEdit.config']), theme.version && /*#__PURE__*/React.createElement(_Tag, {
    color: "arcoblue",
    style: {
      marginLeft: 4
    }
  }, theme.version), /*#__PURE__*/React.createElement(IconCaretDown, {
    className: style['dropdown-icon']
  })));
}
export default ThemeMenu;